import {getParam, insertParam, removeParam} from "../utils/urlQuery.js";

document.addEventListener("DOMContentLoaded", function () {
    let pageOpenEvent = new Event("page-open");
    let oTabContainers = document.querySelectorAll("[otab-container]");
    for (let oTabContainer of oTabContainers) {
        let pushHistory = false;
        let oTabs = oTabContainer.querySelectorAll("[otab-name]");
        let oTabButtons = oTabContainer.querySelectorAll("[otab-button]");
        let last_tab = "";

        var switchTab = (tabName, push = true, auto = false) => {
            oTabContainer.setAttribute("current", tabName);
            // Find the currently visible tab and get its height
            let currentTab = [...oTabs].find(tab => !tab.classList.contains("otab-hidden"));
            let currentHeight = currentTab ? currentTab.offsetHeight : 0;

            // Set the height CSS variable before switching
            oTabContainer.style.setProperty("--last-tab-height", `${currentHeight}px`);

            var thisTab = null;
            var goToDefault = false;
            for (let tab of oTabs) {
                if (tab.getAttribute("otab-name") === tabName) {
                    if (auto === true && tab.getAttribute("no-load-into") !== null) {
                        goToDefault = true;
                        continue;
                    }
                    thisTab = tab;
                    tab.style = "height: auto !important";
                    setTimeout(() => {
                        oTabContainer.style.setProperty("--last-tab-height", `${tab.scrollHeight}px`);
                        tab.style.height = "";
                    }, 200)
                    tab.classList.remove("otab-hidden");
                    tab.setAttribute("aria-hidden", "false");
                    if (tab.getAttribute("otab-callback")) {
                        console.log(tab.getAttribute("otab-callback"));
                        window[tab.getAttribute("otab-callback")]();
                    }
                    tab.dispatchEvent(pageOpenEvent);
                    tab.setAttribute("tabindex", "0");
                } else {
                    tab.setAttribute("aria-hidden", "true");
                    tab.classList.add("otab-hidden");
                    tab.setAttribute("tabindex", "-1");

                }
            }

            if (goToDefault) {
                switchTab(oTabContainer.getAttribute("otab-default"), false, false);
            }

            for (let button of oTabButtons) {
                if (button.getAttribute("otab-button") === tabName) {
                    button.classList.add("otab-button-active");
                } else {
                    button.classList.remove("otab-button-active");
                }
            }

            if (oTabContainer.getAttribute("otab-default") != null && tabName === oTabContainer.getAttribute("otab-default")) {
                removeParam(oTabContainer.getAttribute("otab-container"));
            } else if (last_tab !== tabName && push === true) {
                insertParam(oTabContainer.getAttribute("otab-container"), tabName, pushHistory);
            }

            last_tab = tabName;
            pushHistory = true;

            oTabContainer.dispatchEvent(pageOpenEvent);
        }

        oTabContainer.switchTab = switchTab;

        for (let oTabButton of oTabButtons) {
            if (oTabButton.closest("[otab-container]") != oTabContainer) continue;
            if (oTabContainer.getAttribute("otab-no-replace") == null) {
                oTabButton.innerHTML = oTabButton.getAttribute("otab-button");
            }
            oTabButton.addEventListener("click", function () {
                switchTab(oTabButton.getAttribute("otab-button"));
            });
        }

        function loadFromUrl(auto = true) {
            if (getParam(oTabContainer.getAttribute("otab-container")) != null) {
                switchTab(getParam(oTabContainer.getAttribute("otab-container")), false, auto);
            } else {
                if (oTabContainer.getAttribute("otab-default") != null) {
                    switchTab(oTabContainer.getAttribute("otab-default"), false, false);
                }
            }
        }

        window.addEventListener("popstate", function () {
            loadFromUrl(true);
        });

        loadFromUrl();
    }
});
